// Estilos exclusivos do FormularioPreview (Rede, Tipos de Entrega, Parceiro +
// Escalonamento, Velocidade, Cliente Final, POP e Regional, Equipamentos,
// Meio de Entrega) — extraídos de styles.js (2.3-circuito) na Task 7 da
// decomposição.
const styles = (theme) => ({
	boxContent: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		mb: 1,
		mt: 2,
	},
	boxCampos: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		p: 0.5,
	},
	icons: {
		fontSize: 18,
		color: theme.palette.primary.main,
	},
	typhographyTitle: {
		fontWeight: "bold",
		fontSize: 14,
		color: theme.palette.text.secondary,
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	typographyLabel: {
		fontSize: 14,
		color: theme.palette.text.primary,
		overflow: "hidden",
		textOverflow: "ellipsis",
		cursor: "pointer",
		maxWidth: "150px",
	},
	divider: {
		mt: 2,
		mb: 1,
	},
	boxChip: {
		display: "flex",
		flexWrap: "wrap",
		gap: 1,
	},
});

export default styles;
